// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.student-roster-table {
  border-radius: 10px;
  margin-top: 16px;
}
.student-roster-table .clear-roster-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin: 0px 0px 24px 10px;
  width: 100%;
}
.student-roster-table .filter-wrapper {
  align-items: flex-end;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.student-roster-table .filter-wrapper h5 {
  color: #0669B3;
  font-weight: 700;
}
.student-roster-table .filter-wrapper .select-students-for-group {
  color: #0669B3;
  font-size: 18px;
  font-weight: 600;
}
.student-roster-table .filter-wrapper .roster-table-filter-label {
  color: #0669B3;
  display: flex;
  font-weight: 600;
  flex-direction: column;
  width: 20%;
}
.student-roster-table .filter-wrapper .roster-table-filter-label .roster-table-filter {
  border-radius: 5px;
  border: 1px solid #808080;
  padding: 2px 4px;
  font-size: 14px;
}
.student-roster-table table {
  border-collapse: separate;
  border-spacing: 0px;
  margin-top: 16px;
  width: 100%;
}
.student-roster-table table th {
  border-radius: 5px 5px 0 0;
  border: 1px solid #D1D3D4;
  background-color: #c0def0;
  color: #0A4064;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 8px;
  width: 250px;
}
.student-roster-table table th .icon-container {
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  vertical-align: middle;
}
.student-roster-table table th .table-header-button {
  background: transparent;
  border: none;
}
.student-roster-table table th:last-child {
  width: 50px;
}
.student-roster-table table .checkbox-header {
  text-align: center;
  width: 25px;
}
.student-roster-table table tbody {
  border: 1px solid #D1D3D4;
}
.student-roster-table table tbody td {
  border-left: 1px solid #D1D3D4;
  border-right: 1px solid #D1D3D4;
}
.student-roster-table table tbody td:last-child {
  text-align: center;
}
.student-roster-table table tbody .transparent-button {
  background: transparent;
  border: none;
}
.student-roster-table .back-btn-wrapper {
  margin: 32px -10px 0px 0px;
  text-align: right;
}

.group-table {
  background-color: transparent;
  padding: 4px 0px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/StudentRosterTable.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,mBAAA;EACA,gBAAA;AAUJ;AARI;EACI,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,WAAA;AAUR;AAPI;EACI,qBAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;AASR;AARQ;EACI,cDYC;ECXD,gBAAA;AAUZ;AARQ;EACI,cDQC;ECPD,eAAA;EACA,gBAAA;AAUZ;AARQ;EACI,cDGC;ECFD,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;AAUZ;AATY;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAWhB;AAPI;EACI,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AASR;AARQ;EACI,0BAAA;EACA,yBAAA;EACA,yBDvCA;ECwCA,cD1CF;EC2CE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAUZ;AATY;EACI,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAWhB;AATY;EACI,uBAAA;EACA,YAAA;AAWhB;AARQ;EACI,WAAA;AAUZ;AARQ;EACI,kBAAA;EACA,WAAA;AAUZ;AAPQ;EACI,yBAAA;AASZ;AARY;EACI,8BAAA;EACA,+BAAA;AAUhB;AARY;EACI,kBAAA;AAUhB;AARY;EACI,uBAAA;EACA,YAAA;AAUhB;AANI;EACI,0BAAA;EACA,iBAAA;AAQR;;AALA;EACI,6BAAA;EACA,gBAAA;AAQJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.student-roster-table {\n    border-radius: 10px;\n    margin-top: 16px;\n\n    .clear-roster-btn-wrapper {\n        display: flex;\n        justify-content: flex-end;\n        margin: 0px 0px 24px 10px;\n        width: 100%;\n    }\n\n    .filter-wrapper {\n        align-items: flex-end;\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        h5 {\n            color: $pearl-blue;\n            font-weight: 700;\n        }\n        .select-students-for-group {\n            color: $pearl-blue;\n            font-size: 18px;\n            font-weight: 600;\n        }\n        .roster-table-filter-label {\n            color: $pearl-blue;\n            display: flex;\n            font-weight: 600;\n            flex-direction: column;\n            width: 20%;\n            .roster-table-filter {\n                border-radius: 5px;\n                border: 1px solid $grey3;\n                padding: 2px 4px;\n                font-size: 14px;\n            }\n        }\n    }\n    table {\n        border-collapse: separate;\n        border-spacing: 0px;\n        margin-top: 16px;\n        width: 100%;\n        th {\n            border-radius: 5px 5px 0 0;\n            border: 1px solid $grey1;\n            background-color: $pale-blue;\n            color: $dk-blue;\n            font-size: .95rem;\n            font-weight: 500;\n            padding: 8px;\n            width: 250px;\n            .icon-container {\n                cursor: pointer;\n                display: inline-flex;\n                flex-direction: column;\n                margin-left: 5px;\n                vertical-align: middle;\n            }\n            .table-header-button {\n                background: transparent;\n                border: none;\n            }\n        }\n        th:last-child {\n            width: 50px;\n        }\n        .checkbox-header {\n            text-align: center;\n            width: 25px;\n        }\n\n        tbody {\n            border: 1px solid $grey1;\n            td {\n                border-left: 1px solid $grey1;\n                border-right: 1px solid $grey1;\n            }\n            td:last-child {\n                text-align: center;\n            }\n            .transparent-button {\n                background: transparent;\n                border: none;\n            }\n        }\n    }\n    .back-btn-wrapper {\n        margin: 32px -10px 0px 0px;\n        text-align: right;\n    }\n}\n.group-table {\n    background-color: transparent;\n    padding: 4px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
